import { IDocumentDto } from '@common/features/submission/types';
import { ISelectOption } from '@common/types';
// eslint-disable-next-line @typescript-eslint/ban-types
export const debounce = (fn: Function, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>;

  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

export const checkIfItemIsEmpty = (item: unknown) => {
  if (!item) {
    return true;
  }

  if (Array.isArray(item) && !item.length) {
    return true;
  }

  if ((item as ISelectOption) && (item as ISelectOption).value?.length === 0) {
    return true;
  }

  return false;
};


export function formatDocumentSubTitle(showIds: boolean, name: string | undefined = '', document: IDocumentDto | undefined, showDocumentId: boolean): string {
  if (!showIds) {
    return name;
  }

  const productIds = document?.linkedProductIds?.length
    ? ` - [${document.linkedProductIds.join(', ')}]`
    : '';

  const docId = showDocumentId && document?.documentId
    ? ` - ${document.documentId}`
    : '';

  return `${name}${productIds}${docId}`;
}

/**
 * Email validation pattern (basic validation)
 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates a single email address
 * @param email - Email address to validate
 * @returns true if valid, false otherwise
 */
export const isValidEmail = (email: string): boolean => {
  return EMAIL_PATTERN.test(email.trim());
};

/**
 * Validates multiple email addresses separated by semicolons
 * @param emailString - String containing one or more email addresses separated by semicolons
 * @returns Validation result with success status and optional error message
 */
export const validateEmailAddresses = (emailString: string): { valid: boolean; message?: string } => {
  const emails = emailString
    .split(';')
    .map((email) => email.trim())
    .filter((email) => email.length > 0);

  if (emails.length === 0) {
    return { valid: false, message: 'Email address is required' };
  }

  const invalidEmails = emails.filter((email) => !isValidEmail(email));

  if (invalidEmails.length > 0) {
    return {
      valid: false,
      message: invalidEmails.length === 1
        ? 'Please enter a valid email address'
        : 'Please enter valid email addresses',
    };
  }

  return { valid: true };
};
